<script lang="ts">
    import {email, fetchOrigin, page} from "../data.ts";
    import {onMount} from "svelte";

    let msg = '';

    async function verifyCode() {
        code = code?.trim();
        if (!code || code.length !== 6) {
            msg = 'Code must be 6 digits';
            return;
        }
        msg = '';
        if (!$email) {
            msg = 'Email not set';
            return;
        }
        const result = await fetchOrigin(`/verify-code?${new URLSearchParams({email: $email, code}).toString()}`);
        const json = await result.json();
        if (json.success) {
            page.set('Registration')
        } else {
            msg = json.error;
        }
    }

    let code;

    onMount(() => {
        if ($email === '') {
            console.log('email aint right')
            page.set('EnterEmail')
        }
    })
</script>

<article style="max-width: 720px; margin: 2rem auto;">
    <h1>Enter the code sent to {$email}</h1>
    <p>
        Code will arrive from noreply@wobregistration.org.
    </p>
    <div style="padding: 5px 0"><small on:click={() => page.set('EnterEmail')}>change email</small></div>

    <label>
        Code
        <input type="text" name="code" placeholder="xxxxxx" required bind:value={code}/>
    </label>


    {#if msg}
        <div class="alert alert-warning">
            {msg}
        </div>
    {/if}

    <button on:click={verifyCode}>Submit</button>
</article>